import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 0 16px;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 10px 0px 100px 0;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

export const Title = styled.div`
font-family: 'Caveat', cursive;
font-size: 52px;
text-align: center;
font-weight: 700;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 40px;
  }
`;

export const TitleUnderline = styled.div`
  width: 170px;
  margin: -8px auto 0 auto;
`;

export const CarouselRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const CardContainer = styled.div`
    display: flex;
    align-items: stretch;
    gap: 28px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    padding: 4px 4px 16px 4px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
    & > * {
        scroll-snap-align: start;
        flex-shrink: 0;
    }
`;
